const gtmInit = (w, d, s, l, i) => {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
};

export function tapTriggerListener(element) {
  const nodelist = element.querySelectorAll('[data-type-tap]');
  const tapTriggerList = Array.prototype.slice.call(nodelist, 0);
  tapTriggerList.forEach(item => {
    item.addEventListener('click', e => {
      const dataset = e.currentTarget.dataset;
      const contentIds = dataset.contentIds
        ? dataset.contentIds.replace(/'/g, '"')
        : '';
      // GTMの仕様でpageIdを設定しない場合は、urlのパスのhttp://content.ameba.jp/campaigns/{campaign_key}
      // campaign_keyが自動的に設定されます
      const obj = {
        event: 'tapTrigger',
        commonPage_pageId: dataset.pageId ? dataset.pageId : '',
        contents_tapId: dataset.tapId ? dataset.tapId : '',
        contents_orderId: dataset.orderId ? dataset.orderId : '',
        contents_contentIds: contentIds ? contentIds : '',
        contents_bloggerAmebaId: dataset.bloggerAmebaId ? dataset.bloggerAmebaId : '',
      };
      window.dataLayer.push(obj);
    });
  });
}

gtmInit(window, document, 'script', 'dataLayer', 'GTM-K3THL9');
tapTriggerListener(window.document);
